import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { contestEntriesBackend } from './contest-entries.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { contestEntriesReducer } from './contest-entries.reducer';

// FIXME: remove that
backend.contestEntries = contestEntriesBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('contestEntries', contestEntriesReducer),
    /* DatastoreBackendModule.forFeature(
      'contestEntries',
      contestEntriesBackend,
    ),*/
  ],
})
export class DatastoreContestEntriesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/contest-entries/contest-entries.module.ts